import type { Aisle } from '../../lib/aisleGrouping'

type Props = {
  aisle: Aisle
  count: number
}

export function AisleHeader({ aisle, count }: Props) {
  return (
    <div className="mb-2 flex items-baseline gap-2 px-0.5">
      <h2 className="font-serif text-[14px] italic text-ink">{aisle}</h2>
      <div className="flex-1 h-px bg-border-sand" />
      <span className="text-[10px] uppercase tracking-[0.08em] font-medium text-ink-muted">
        {count}
      </span>
    </div>
  )
}
